import { useState } from "react";

import { useNavigate } from "react-router-dom";

import axios from 'axios';
import {url,urlLive} from '../../../../constant';

//  @mui material full-page-loader
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function ResetPassword() {

  const navigate = useNavigate();
  // const [email, setEmail] = useState("rizwaneng6@gmail.com");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // navigate("/authentication/Reset-password-with-code")

    try {
      setOpen(true);
      const response = await axios.post(`${url}auth/send-reset-code`, { email });
      if (response.status === 200) {
        // setMessage("A reset code has been sent to your email address.");
        setMessage("Verifica la tua mail, sono state inviate le info per cambiare password.");
        // Redirect to login page after successful password reset
        setTimeout(() => {
          setOpen(false);
          // navigate("/authentication/Reset-password-with-code?email=" + email);
          // setMessage("");
        }, 2000);

      }
    } catch (error) {

      setOpen(false);
      // setMessage("Failed to send reset code. Please check the email address.");
      setMessage("Reset password non riuscito.");
      setTimeout(()=>{
        setMessage("");
      },1500);

    }

  };

  return (
    <BasicLayout coverHeight="50vh" bgImage={bgImage}>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        }}

        open={open}
        transitionDuration={500}  // Smooth transition for the backdrop
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={3}
          mb={2}
          textAlign="center"
          // sx={{
          //   background: "#6281eb", // Initial background color
          //   "&:hover": {
          //     background: "#4a65d8", // Hover color
          //   },
          // }}

          sx={{
            background: '#183759', // 🔹 Your main color
            "&:hover": {
              background: '#204b80', // ✨ Slightly lighter for hover
            },
          }}

        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            {/* Reset Password */}
            Reimposta password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            {/* Enter your email address to receive a reset code. */}
            Inserisci la tua email per ricevere il link per effettuare il reset
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={4}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            {/* Display the message if the email is sent */}
            {message && (
              <MDBox mb={2} mt={2} textAlign="center">
                <MDTypography variant="body1" color="success.main">
                  {message}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={6} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                // sx={{
                //   background: "#6281eb", // Initial background color
                //   "&:hover": {
                //     background: "#4a65d8", // Hover state color
                //   },
                // }}

                sx={{
                  background: '#183759', // 🔹 Your main color
                  "&:hover": {
                    background: '#204b80', // ✨ Slightly lighter for hover
                  },
                }}

                fullWidth
                type="submit"
              >
                {/* Reset Password */}
                Reimposta password
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
  
}

export default ResetPassword;
